// extracted by mini-css-extract-plugin
export default {"registration-details":"registration-details_registration-details__2ff5U"};